"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Activity$icons;

var Activity = function Activity(props) {
  var activity = props.activity,
      duration = props.duration,
      isOutdated = props.isOutdated,
      bsSize = props.bsSize,
      onClick = props.onClick,
      className = props.className;

  if (!activity) {
    return null;
  }

  var icon = Activity.icons[activity];
  var wrapperClassNames = (0, _classnames.default)('activity', "activity-".concat(activity), isOutdated && 'opacity-50', bsSize && "activity-".concat(bsSize), className && className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: wrapperClassNames,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'activity-icon'
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "rioglyph ".concat(icon)
  })), duration && /*#__PURE__*/_react.default.createElement("span", {
    className: 'activity-text'
  }, duration));
};

Activity.AVAILABLE = 'available';
Activity.DRIVING = 'driving';
Activity.RESTING = 'resting';
Activity.WORKING = 'working';
Activity.icons = (_Activity$icons = {}, (0, _defineProperty2.default)(_Activity$icons, Activity.WORKING, 'rioglyph-status-working'), (0, _defineProperty2.default)(_Activity$icons, Activity.AVAILABLE, 'rioglyph-status-available'), (0, _defineProperty2.default)(_Activity$icons, Activity.DRIVING, 'rioglyph-status-driving'), (0, _defineProperty2.default)(_Activity$icons, Activity.RESTING, 'rioglyph-status-resting'), _Activity$icons);
Activity.SIZE_SM = 'sm';
Activity.SIZE_LG = 'lg';
Activity.SIZE_XL = 'xl';
Activity.defaultProps = {
  className: '',
  isOutdated: false,
  onClick: function onClick() {}
};
Activity.propTypes = {
  activity: _propTypes.default.oneOf([Activity.AVAILABLE, Activity.DRIVING, Activity.RESTING, Activity.WORKING]).isRequired,
  bsSize: _propTypes.default.oneOf([Activity.SIZE_SM, Activity.SIZE_LG, Activity.SIZE_XL]),
  className: _propTypes.default.string,
  duration: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  isOutdated: _propTypes.default.bool,
  onClick: _propTypes.default.func.isRequired
};
var _default = Activity;
exports.default = _default;